import { z } from 'zod';

export interface HedgingToggles {
  deltaThreshold: boolean;
  deltaThresholdUpper: boolean;
  deltaThresholdLower: boolean;
  deltaTarget: boolean;
}

export const createHedgingSchema = (toggles: HedgingToggles) =>
  z
    .object({
      frequency: z.string().min(1, 'Hedging frequency is required'),
      includeFundingRates: z.boolean(),

      deltaThreshold: z.boolean(),
      deltaThresholdValue: toggles.deltaThreshold
        ? z.string().min(1, 'Delta threshold is required')
        : z
            .string()
            .optional()
            .transform((v) => v ?? ''),

      deltaThresholdUpper: z.boolean(),
      deltaThresholdUpperValue: toggles.deltaThresholdUpper
        ? z.string().min(1, 'Delta threshold upper is required')
        : z
            .string()
            .optional()
            .transform((v) => v ?? ''),

      deltaThresholdLower: z.boolean(),
      deltaThresholdLowerValue: toggles.deltaThresholdLower
        ? z.string().min(1, 'Delta threshold lower is required')
        : z
            .string()
            .optional()
            .transform((v) => v ?? ''),

      deltaTarget: z.boolean(),
      deltaTargetValue: toggles.deltaTarget
        ? z.string().min(1, 'Delta target is required')
        : z
            .string()
            .optional()
            .transform((v) => v ?? ''),

      includeTokenBalanceInDelta: z.boolean(),
    })
    .superRefine((data, ctx) => {
      if (
        toggles.deltaThresholdLower &&
        toggles.deltaThresholdUpper &&
        data.deltaThresholdLowerValue &&
        data.deltaThresholdUpperValue
      ) {
        const lower = parseFloat(data.deltaThresholdLowerValue);
        const upper = parseFloat(data.deltaThresholdUpperValue);

        if (!isNaN(lower) && !isNaN(upper) && lower >= upper) {
          ctx.addIssue({
            path: ['deltaThresholdLowerValue'],
            code: z.ZodIssueCode.custom,
            message: 'Lower threshold must be less than upper threshold',
          });
        }
      }
    });

export type HedgingSchemaType = z.infer<ReturnType<typeof createHedgingSchema>>;
